/* eslint-disable */
import { Box, Card, Container, Grid, useTheme } from "@mui/material";
import React, { useEffect } from "react";
import ExploreFeature from "./ExploreFeature";
import { SectionWrapper } from "./AiBlogWriter";

const AiBlogGeneratorMain = () => {
  const theme = useTheme();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <SectionWrapper className="SSSSS">
      <Container maxWidth="">
        <ExploreFeature />
        {/* <Box sx={{ flexGrow: 1 }}>
          <Card
            sx={{
              padding: "18px 14px",
              border: `1px solid ${theme.palette.divider}`,
              boxShadow: "none",
            }}
          >
          </Card>
        </Box> */}
      </Container>
    </SectionWrapper>
  );
};

export default AiBlogGeneratorMain;
